import React, { createContext, useContext, useState } from "react";
import { Account} from "../../TeamJoiner";

interface SelectedAccountContextProps {
    selectedAccount: Account | undefined;
    setSelectedAccount: (account: Account) => void;
}

const SelectedAccountContext = createContext<SelectedAccountContextProps | undefined>(undefined);

export const SelectedAccountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedAccount, setSelectedAccount] = useState<Account | undefined>(undefined);

    return (
        <SelectedAccountContext.Provider value={{ selectedAccount, setSelectedAccount }}>
            {children}
        </SelectedAccountContext.Provider>
    );
};

export const useSelectedAccount = () => {
    const context = useContext(SelectedAccountContext);
    if (!context) {
        throw new Error("useSelectedAccount must be used within a SelectedAccountProvider");
    }
    return context;
};